import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

const clickHandler = () => document.location.href = '/my/create-classroom/';

/**
 * The button that takes teachers to create a new classroom
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const CreateClassroomButton = props => {
	const { btnClass, disabled } = props;

	return (
		<Button color={'primary'} className={btnClass} onClick={clickHandler}
		        disabled={disabled}
		>Create a Classroom</Button>
	);
};

export default CreateClassroomButton;

CreateClassroomButton.propTypes = {
	btnClass: PropTypes.string,
	disabled: PropTypes.bool
};
